export default __webpack_public_path__ + "static/media/6f802ec4928efd14606a55c86c5afb46.974c6535.png";